var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-image-container"},[_c('img',{staticClass:"profile-image",attrs:{"src":_vm.src,"alt":_vm.altText}})])}
var staticRenderFns = []

export { render, staticRenderFns }